import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// 🇫🇷 French
import frGenerale from "./assets/translate/fr/generale.json";
import frHome from "./assets/translate/fr/home.json";
import frAbout from "./assets/translate/fr/about.json";
import frAwakening from "./assets/translate/fr/awakening.json";
import frContact from "./assets/translate/fr/contact.json";

// 🇬🇧 English
import enGenerale from "./assets/translate/en/generale.json";
import enHome from "./assets/translate/en/home.json";
import enAbout from "./assets/translate/en/about.json";
import enAwakening from "./assets/translate/en/awakening.json";
import enContact from "./assets/translate/en/contact.json";

i18n.use(initReactI18next).init({
  resources: {
    fr: {
      translation: {
        ...frGenerale,
        ...frHome,
        ...frAbout,
        ...frAwakening,
        ...frContact,
      },
    },
    en: {
      translation: {
        ...enGenerale,
        ...enHome,
        ...enAbout,
        ...enAwakening,
        ...enContact,
      },
    },
  },
  lng: "fr", // langue par défaut
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
